const queryApp = {}

// 特定のクエリの有無を確認し、その情報を一定時間保持する
// query_key: キー
// query_value: バリュー

queryApp.isQuery = function(query_key, query_value, localstorage_name = 'storageQueryApp', localstorage_valid_date = 'storageQueryAppValidDate') {

  if(query_key == null || query_value == null) {
    return false;
  }
  
  // localStorageのデータの取得
  const storageQueryApp = localStorage.getItem(localstorage_name)
  const storageQueryAppValidDateStr = localStorage.getItem(localstorage_valid_date)

  // クエリ取得
  const decodedQuery = decodeURIComponent(window.location.search);
  const searchParams = new URLSearchParams(decodedQuery);

  if(searchParams.has(query_key)){
    const query_value_by_url = decodeURIComponent(searchParams.get(query_key));
    const dtNow = new Date()
    if(query_value_by_url == query_value) { //trueのときlocalStorageを更新し値を返す
      dtNow.toISOString()
      localStorage.setItem(localstorage_name, true);
      localStorage.setItem(localstorage_valid_date, dtNow);
      return true;
    }
  }

  // localStorageにデータがある場合期限を確認し期限内ならば値を返す、falseならばlocalStorageは更新しない
  if (storageQueryApp) {
    const dtSevendaysAgo = new Date()
    dtSevendaysAgo.setDate(dtSevendaysAgo.getDate() - 7); //有効期限7日
    const storageQueryAppValidDate = new Date(storageQueryAppValidDateStr);
    if( storageQueryAppValidDate >= dtSevendaysAgo ) {
      return storageQueryApp;
    } else {
      localStorage.removeItem(localstorage_name);
      localStorage.removeItem(localstorage_valid_date);
    }
  }

  // クエリもローカルストレージもない場合はfalse
  return false;
}